import StripeKeysModal from "../../../../Components/popUpComponents/StripeKeysModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  addNewInvoicePaymentMethod,
  addNewInvoicePaymentMethodSuccess,
  addNewInvoiceStatus,
  addNewInvoiceStatusSuccess,
  deleteInvoicePaymentMethod,
  deleteInvoicePaymentMethodSuccess,
  deleteInvoiceStatus,
  deleteInvoiceStatusSuccess,
  getInvoicePaymentMethodList,
  getInvoiceStatusList,
  updateInvoicePaymentMethod,
  updateInvoicePaymentMethodSuccess,
  updateInvoiceStatus,
  updateInvoiceStatusSuccess,
} from "../../../../store/invoiceCrmIT/action";
import { toast } from "react-toastify";
import {
  createPaymentTerms,
  createPaymentTermsSuccess,
  deletePaymentTerms,
  deletePaymentTermsSuccess,
  getPaymentTermsList,
  updatePaymentTerms,
  updatePaymentTermsSuccess,
} from "../../../../store/paymentTerm/action";
import { getMasterPaymentProviderList } from "../../../../store/masterPaymentProvider/action";
export default function InvoicingSettings() {
  const dispatch = useDispatch();

  const { invoiceStatusList, invoicePaymentMethodListAPI } = useSelector(
    (state) => ({
      invoiceStatusList:
        state.InvoiceCrmIT.invoiceStatusList?.invoicestatus_list,
      invoicePaymentMethodListAPI:
        state.InvoiceCrmIT.invoicePaymentMethodList?.paymentmethod_list,
    })
  );

  const { paymentTermsListAPI } = useSelector((state) => ({
    paymentTermsListAPI: state.PaymentTerm.paymentTermsList?.paymentterm_list,
  }));
  const { masterPaymentProvidersListAPI } = useSelector((state) => ({
    masterPaymentProvidersListAPI:
      state.MasterPaymentProvider.masterPaymentProvidersList
        ?.masterpaymentprovider_list,
  }));
  const [paymentTerm, setPaymentTerm] = useState(false);
  const [statusList, setStatusList] = useState([]);
  // Change #100739 - Stripe keys for a payment method
  const [stripeMethodId, setStripeMethodId] = useState("");
  const [stripeOpen, setStripeOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [config, setConfig] = useState(null);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    LogicValue: "", //Duration
    LogicType: "", // Drop Down a type
    MasterPaymentProvider_Id: "",
  });

  const logicType = [
    {
      label: "Days",
      value: "1",
    },
    {
      label: "Months",
      value: "2",
    },
    {
      label: "Day of Next month",
      value: "3",
    },
    {
      label: "Last Day of the month",
      value: "4",
    },
    {
      label: "Last Working Day of the month",
      value: "5",
    },
  ];
  const [noColourChoiceRequired, setNoColourChoiceRequired] = useState(false);

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(addNewInvoiceStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Task Type create
      dispatch(addNewInvoicePaymentMethod([createStatus]));
    }
    if (activeTab === "3") {
      dispatch(createPaymentTerms([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = invoiceStatusList?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(false);
      setPaymentTerm(false);
      setConfig(null);
    }
    if (activeTab === "2") {
      data = invoicePaymentMethodListAPI?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(true);
      setPaymentTerm(false);
      setConfig({
        name: "MasterPaymentProvider",
        data: masterPaymentProvidersListAPI,
      });
    }
    if (activeTab === "3") {
      setPaymentTerm(true);
      data = paymentTermsListAPI?.sort((a, b) => b.Id - a.Id);
      setConfig(null);
    }

    setStatusList(data);
  }, [
    invoiceStatusList,
    invoicePaymentMethodListAPI,
    paymentTermsListAPI,
    activeTab,
  ]);

  useEffect(() => {
    dispatch(getInvoiceStatusList());
    dispatch(getInvoicePaymentMethodList());
    dispatch(getPaymentTermsList());
    dispatch(getMasterPaymentProviderList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Invoice Statuses",
    },
    {
      id: "2",
      name: "Payment Methods",
    },
    {
      id: "3",
      name: "Payment Terms",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete
      dispatch(deleteInvoiceStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      // Task Type delete
      dispatch(deleteInvoicePaymentMethod([deleteStatus]));
    }
    if (activeTab === "3") {
      // Task Type delete
      dispatch(deletePaymentTerms([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      LogicValue: updateItemStatus?.LogicValue,
      LogicType: updateItemStatus?.LogicType,
      MasterPaymentProvider_Id: updateItemStatus?.MasterPaymentProvider_Id,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update
        dispatch(updateInvoiceStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Task Type update
        dispatch(updateInvoicePaymentMethod([updateNewStatus]));
      }
      if (activeTab === "3") {
        // Task Type update
        dispatch(updatePaymentTerms([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // success Add Update Delete
  const {
    addInvoiceStatusSuccessApi,
    deleteInvoiceStatusSuccessAPI,
    updateInvoiceStatusSuccessAPI,
    addInvoicePaymentMethodSuccessAPI,
    deleteInvoicePaymentMethodSuccessAPI,
    updateInvoicePaymentMethodSuccessAPI,
  } = useSelector((state) => ({
    addInvoiceStatusSuccessApi: state.InvoiceCrmIT.addInvoiceStatusSuccess,
    deleteInvoiceStatusSuccessAPI:
      state.InvoiceCrmIT.deleteInvoiceStatusSuccess,
    updateInvoiceStatusSuccessAPI:
      state.InvoiceCrmIT.updateInvoiceStatusSuccess,
    addInvoicePaymentMethodSuccessAPI:
      state.InvoiceCrmIT.addInvoicePaymentMethodSuccess,
    deleteInvoicePaymentMethodSuccessAPI:
      state.InvoiceCrmIT.deleteInvoicePaymentMethodSuccess,
    updateInvoicePaymentMethodSuccessAPI:
      state.InvoiceCrmIT.updateInvoicePaymentMethodSuccess,
  }));
  const {
    createPaymentTermsSuccessAPI,
    updatePaymentTermsSuccessAPI,
    deletePaymentTermsSuccessAPI,
  } = useSelector((state) => ({
    createPaymentTermsSuccessAPI: state.PaymentTerm.createPaymentTerms,
    updatePaymentTermsSuccessAPI: state.PaymentTerm.updatePaymentTerms,
    deletePaymentTermsSuccessAPI: state.PaymentTerm.deletePaymentTerms,
  }));

  // Add  Success Invoice Status
  useEffect(() => {
    if (isEmpty(addInvoiceStatusSuccessApi)) return;
    if (addInvoiceStatusSuccessApi?.status === 200) {
      toast.success(addInvoiceStatusSuccessApi?.message);
      dispatch(getInvoiceStatusList());
    } else {
      toast.error(addInvoiceStatusSuccessApi?.message);
    }
    dispatch(addNewInvoiceStatusSuccess([]));
  }, [addInvoiceStatusSuccessApi]);
  // Delete Success Invoice Status
  useEffect(() => {
    if (isEmpty(deleteInvoiceStatusSuccessAPI)) return;
    if (deleteInvoiceStatusSuccessAPI?.status === 200) {
      toast.success(deleteInvoiceStatusSuccessAPI?.message);
      dispatch(getInvoiceStatusList());
      setDeleteModal(false);
    } else {
      toast.error(deleteInvoiceStatusSuccessAPI?.message);
    }
    dispatch(deleteInvoiceStatusSuccess([]));
  }, [deleteInvoiceStatusSuccessAPI]);
  // Update Success Invoice Status
  useEffect(() => {
    if (isEmpty(updateInvoiceStatusSuccessAPI)) return;
    if (updateInvoiceStatusSuccessAPI?.status === 200) {
      toast.success(updateInvoiceStatusSuccessAPI?.message);
      dispatch(getInvoiceStatusList());
    } else {
      toast.error(updateInvoiceStatusSuccessAPI?.message);
    }
    dispatch(updateInvoiceStatusSuccess([]));
  }, [updateInvoiceStatusSuccessAPI]);
  // Add  Success Invoice Payment Method
  useEffect(() => {
    if (isEmpty(addInvoicePaymentMethodSuccessAPI)) return;
    if (addInvoicePaymentMethodSuccessAPI?.status === 200) {
      toast.success(addInvoicePaymentMethodSuccessAPI?.message);
      dispatch(getInvoicePaymentMethodList());
    } else {
      toast.error(addInvoicePaymentMethodSuccessAPI?.message);
    }
    dispatch(addNewInvoicePaymentMethodSuccess([]));
  }, [addInvoicePaymentMethodSuccessAPI]);
  // Delete Success Invoice Payment Method
  useEffect(() => {
    if (isEmpty(deleteInvoicePaymentMethodSuccessAPI)) return;
    if (deleteInvoicePaymentMethodSuccessAPI?.status === 200) {
      toast.success(deleteInvoicePaymentMethodSuccessAPI?.message);
      dispatch(getInvoicePaymentMethodList());
      setDeleteModal(false);
    } else {
      toast.error(deleteInvoicePaymentMethodSuccessAPI?.message);
    }
    dispatch(deleteInvoicePaymentMethodSuccess([]));
  }, [deleteInvoicePaymentMethodSuccessAPI]);
  // Update Success Invoice Payment Method
  useEffect(() => {
    if (isEmpty(updateInvoicePaymentMethodSuccessAPI)) return;
    if (updateInvoicePaymentMethodSuccessAPI?.status === 200) {
      toast.success(updateInvoicePaymentMethodSuccessAPI?.message);
      dispatch(getInvoicePaymentMethodList());
    } else {
      toast.error(updateInvoicePaymentMethodSuccessAPI?.message);
    }
    dispatch(updateInvoicePaymentMethodSuccess([]));
  }, [updateInvoicePaymentMethodSuccessAPI]);

  // Add Success Payment Terms
  useEffect(() => {
    if (isEmpty(createPaymentTermsSuccessAPI)) return;
    if (createPaymentTermsSuccessAPI?.status === 200) {
      toast.success(createPaymentTermsSuccessAPI?.message);
      dispatch(getPaymentTermsList());
    } else {
      toast.error(createPaymentTermsSuccessAPI?.message);
    }
    dispatch(createPaymentTermsSuccess([]));
  }, [createPaymentTermsSuccessAPI]);
  // Update Success Payment Terms
  useEffect(() => {
    if (isEmpty(updatePaymentTermsSuccessAPI)) return;
    if (updatePaymentTermsSuccessAPI?.status === 200) {
      toast.success(updatePaymentTermsSuccessAPI?.message);
      dispatch(getPaymentTermsList());
    } else {
      toast.error(updatePaymentTermsSuccessAPI?.message);
    }
    dispatch(updatePaymentTermsSuccess([]));
  }, [updatePaymentTermsSuccessAPI]);
  // Delete Success Payment Terms
  useEffect(() => {
    if (isEmpty(deletePaymentTermsSuccessAPI)) return;
    if (deletePaymentTermsSuccessAPI?.status === 200) {
      toast.success(deletePaymentTermsSuccessAPI?.message);
      dispatch(getPaymentTermsList());
      setDeleteModal(false);
    } else {
      toast.error(deletePaymentTermsSuccessAPI?.message);
    }
    dispatch(deletePaymentTermsSuccess([]));
  }, [deletePaymentTermsSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Invoicing Settings"
        description="Invoice statuses, payment methods and payment terms for invoicing"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          noColourChoiceRequired={noColourChoiceRequired}
          logicType={logicType}
          paymentTerm={paymentTerm}
          config={config}
        />

        {/* Change #100739 - a payment method takes cards through its Stripe account */}
        {activeTab === "2" && (
          <div className="d-flex flex-wrap align-items-center gap-2 mt-3 pt-3 border-top">
            <span className="fw-semibold">Take card payments with Stripe:</span>
            <select
              className="form-select form-select-sm"
              style={{ maxWidth: 260 }}
              value={stripeMethodId}
              onChange={(e) => setStripeMethodId(e.target.value)}
            >
              <option value="">Choose a payment method…</option>
              {(invoicePaymentMethodListAPI || []).map((m) => (
                <option key={m.Id} value={m.Id}>
                  {m.Name}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="btn btn-sm btn-primary"
              disabled={!stripeMethodId}
              onClick={() => setStripeOpen(true)}
            >
              Stripe keys…
            </button>
            <small className="text-muted w-100">
              Create a method (e.g. "Card (Stripe)") above, then add its Stripe keys here. Pick it on an online shop under Store Settings &gt; Card payments.
            </small>
          </div>
        )}
      </SettingsPanel>

      <StripeKeysModal
        open={stripeOpen}
        paymentMethodId={stripeMethodId}
        onClose={() => setStripeOpen(false)}
      />
    </>
  );
}
